import BaseComponent from 'primevue/basecomponent';

var script = {
    name: 'ColumnGroup',
    extends: BaseComponent,
    props: {
        type: {
            type: String,
            default: null
        }
    },
    render() {
        return null;
    }
};

export { script as default };
